let Vue

export default function api (_Vue) {
  if (Vue && _Vue === Vue) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(
        '[service] already installed. Vue.use(service) should be called only once.'
      )
    }
    return
  }

  Vue = _Vue

  Vue.mixin({
    beforeCreate: function () {
      const options = this.$options
      // service injection
      if (options.service) {
        this.$api = typeof options.service === 'function'
          ? options.service()
          : options.service
      } else if (options.parent && options.parent.$api) {
        this.$api = options.parent.$api
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/plugins/install/service.js